module.exports = __webpack_public_path__ + "static/media/3 medusa portrait realistic snake greek mythology.1280x2275.908d1bd5.webp";